import isObjectEmpty from 'utils/isObjectEmpty'

const routeSlicer = (response, begin, end = undefined) =>
  response.request.responseURL.split('/').slice(begin, end).join('/')

const getMessage = (response = {}, success = true) => {
  const { status } = response

  if (isObjectEmpty(response)) return ''

  if (response.config.method === 'get' && success) return ''

  const isLogin = routeSlicer(response, -1) === 'user_token'
  const isRecover = routeSlicer(response, -2) === 'password/recover'
  const isPassword = routeSlicer(response, -2) === 'password/edit'
  const isFetch = routeSlicer(response, -3).startsWith(
    'medicoes/horarias/fetch'
  )
  const isCnpj = routeSlicer(response, -3).startsWith('acl/unidades/cnpj?')

  const errors = response.data?.errors
  let msgErro = ''
  if (errors && !isObjectEmpty(errors)) {
    msgErro = typeof errors === 'string' ? errors : getErrorMessage(errors)
  }

  switch (status) {
    case 200:
      return 'Operação realizada com sucesso.'
    case 201: {
      if (isLogin) return 'Login realizado com sucesso.'
      return 'Registro criado com sucesso.'
    }
    case 204: {
      if (isRecover) return 'Instruções foram enviadas para o e-mail informado.'
      if (isPassword) return 'Senha alterada com sucesso.'
      if (isFetch)
        return 'Coleta agendada com sucesso. Aguarde o retorno por e-mail.'
      return 'Operação realizada com sucesso.'
    }
    case 401:
      return 'Sua sessão expirou. Faça login novamente.'
    case 403:
      return 'Você não possui permissão para esta operação.'
    case 404: {
      if (isLogin) return 'E-mail e/ou senha inválido(s).'
      return 'O recurso solicitado não foi encontrado.'
    }
    case 422:
      if (isCnpj) return 'CNPJ não encontrado na SCDE.'
      if (msgErro) return msgErro
      return 'Não foi possível salvar.'
    case 500:
      if (msgErro) return msgErro
      return 'Um erro interno ocorreu no servidor.'
    default:
      if (msgErro) return msgErro
      return 'Um erro desconhecido ocorreu.'
  }
}

const getErrorMessage = errors =>
  Object.values(errors)[0][0] ? Object.values(errors)[0][0] : ''

export default getMessage
